import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            pages: [],
        }
    },
    mutations: {
        setPages(state, value) {
            state.pages = value;
        }
    },
    actions: {
        searchPage({state, commit, getters}, firstName){
            return new Promise((resolve, reject) => {
                ApiService.get('/page/public-search', { published_page: 1, full_name: encodeURI(firstName) } )
                    .then((response) => {
                        commit('setPages', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            });
        }
    }
};


